module.exports = function(){ /* empty */ };


/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-google-recaptcha/~/core-js/library/modules/$.add-to-unscopables.js
 ** module id = 2834
 ** module chunks = 0
 **/